import { NavigateFunction } from 'react-router-dom'
import { ReconciliationStep } from '../models/reconciliation'
import {
  goToReconciliationAccountPage,
  goToReconciliationContactsPage,
  goToReconciliationLeasedAssetsPage,
  goToReconciliationPropertyAssetsPage,
  goToReconciliationSummaryPage,
} from './routeActions'

export function getStepFromPath(pathname: string): ReconciliationStep | null {
  if (pathname.includes('/account')) {
    return ReconciliationStep.AccountInformation
  }

  if (pathname.includes('/contacts')) {
    return ReconciliationStep.Contacts
  }

  if (pathname.includes('/assets')) {
    return ReconciliationStep.PropertyAssetList
  }

  if (pathname.includes('/leased-assets')) {
    return ReconciliationStep.LeasedAssetList
  }

  if (pathname.includes('/summary')) {
    return ReconciliationStep.Summary
  }

  return null
}

export function mapToStep(stepName: string): ReconciliationStep {
  if (stepName === 'Account Information') {
    return ReconciliationStep.AccountInformation
  }

  if (stepName === 'Contacts') {
    return ReconciliationStep.Contacts
  }

  if (stepName === 'Contacts') {
    return ReconciliationStep.Contacts
  }

  if (stepName === 'Property Asset List') {
    return ReconciliationStep.PropertyAssetList
  }

  if (stepName === 'Leased Asset List') {
    return ReconciliationStep.LeasedAssetList
  }

  if (stepName === 'Summary & Signature') {
    return ReconciliationStep.Summary
  }

  if (stepName === 'Reconciled') {
    return ReconciliationStep.Reconciled
  }

  throw new Error(`Could not map step "${stepName}"`)
}

export function nextStep(
  navigate: NavigateFunction,
  accountId: number | string,
  completedSteps: ReconciliationStep[],
): void {
  if (!completedSteps.includes(ReconciliationStep.AccountInformation)) {
    return goToReconciliationAccountPage(navigate, { accountId })
  }

  if (!completedSteps.includes(ReconciliationStep.Contacts)) {
    return goToReconciliationContactsPage(navigate, { accountId })
  }

  if (!completedSteps.includes(ReconciliationStep.PropertyAssetList)) {
    return goToReconciliationPropertyAssetsPage(navigate, { accountId })
  }

  if (!completedSteps.includes(ReconciliationStep.LeasedAssetList)) {
    return goToReconciliationLeasedAssetsPage(navigate, { accountId })
  }

  if (!completedSteps.includes(ReconciliationStep.Summary)) {
    return goToReconciliationSummaryPage(navigate, { accountId })
  }

  return goToReconciliationAccountPage(navigate, { accountId })
}

export function hasWorkflowBeenCompleted(completedSteps: ReconciliationStep[]): boolean {
  const hasBeenCompleted = [
    ReconciliationStep.AccountInformation,
    ReconciliationStep.Contacts,
    ReconciliationStep.PropertyAssetList,
    ReconciliationStep.LeasedAssetList,
    ReconciliationStep.Summary,
    ReconciliationStep.Reconciled,
  ].every((step) => completedSteps.includes(step))

  return hasBeenCompleted
}
